import * as React from 'react'
import { FC } from 'react'

import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Theme, useTheme } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'

const getStyles = (theme: Theme) => ({
  label: {
    color: theme.palette.text.primary,
    fontSize: '12px',
  },

  name: {
    color: theme.palette.text.primary,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '24px',
  },

  nameLink: {
    font: 'inherit',
    color: '#005aa3',
    '&:hover': {
      textDecoration: 'none',
    },
  },

  prefix: {
    fontFamily: 'Source Sans Pro Bold',
  },

  prefixSeparator: {
    margin: `0 ${theme.spacing(0.4)}`,
  },

  subName: {
    color: 'inherit',
    fontFamily: 'Source Sans Pro',
    fontSize: '21px',
  },

  chevron: {
    margin: `${theme.spacing(-0.2)} 0 0 0`,
  },
})

interface Props {
  label?: string
  labelPrefix?: string
  name: string
  subName?: string
  entityId: number
  detailUrl?: string
}

export const EntityName: FC<Props> = (props) => {
  const { label, labelPrefix, name, subName, entityId, detailUrl } = props
  const styles = getStyles(useTheme())
  const nameContent = (
    <>
      {name}
      {subName && (
        <span style={styles.subName}> {`${name ? ' - ' : ''}${subName}`}</span>
      )}
    </>
  )
  return (
    <>
      {label && (
        <Typography sx={styles.label}>
          {labelPrefix && (
            <>
              <span style={styles.prefix}>{labelPrefix}</span>
              <span style={styles.prefixSeparator}>
                <ChevronRightIcon sx={styles.chevron} fontSize="small" />
              </span>
            </>
          )}
          {label}
        </Typography>
      )}
      <Typography sx={styles.name} data-test-id={`lead-title_${entityId}`}>
        {detailUrl ? (
          <Link component={RouterLink} to={detailUrl} sx={styles.nameLink}>
            {nameContent}
          </Link>
        ) : (
          nameContent
        )}
      </Typography>
    </>
  )
}

EntityName.displayName = 'EntityName'
